import axios from 'axios'
import {errorHelper, messageHelper} from '../helper.js'
import { 
    CALENDAR_LIST_URL, 
    UPDATE_EXP_RESPONSIBLES_URL, 
    UPDATE_CALENDAR_REC_URL,
    DELETE_CALENDAR_REC_URL,
    STATION_WORKLOAD_URL,
    } from '../../../vars'

/**
 * @namespace Calendar
 * @description Календарь (Page: /calendar)
 */
export default {
    state: {
        calendars: [],
        calendarsData:{},

        isInit: false,
        calendars_by_station: {
            // 1: {                            // draft
            //         calendars: [],
            //         noData: true
            //     },    
        },
        in_house_works: {
            // 1: {                            // draft
            //         in_house: [],
            //         loaded: false
            //     },    
        },
        updateCurrent: false,
        need_update_inhouse_view: 0,
    },
    mutations: {
        UPDATE_CURRENT_CALENDAR(state, data) {
            state.updateCurrent = data
        },
        INIT_CALENDAR_LIST(state, data){
            data.forEach(item => {
                if(item.type == 'station'){
                    state.calendars_by_station[item.id] = {
                        calendars: [],
                        loaded: false,
                    }
                    state.in_house_works[item.id] = {
                        in_house: [],
                        loaded: false,
                    }
                }
            })
            state.isInit = true;
        },

        UPDATE_CALENDAR_LIST(state, data) {
            state.calendars_by_station[data.station_id].calendars = data.data;
            state.calendars_by_station[data.station_id].loaded = true;
        },
      
        UPDATE_INHOUSE_LIST(state, data) {
            state.in_house_works[data.station_id].in_house = data.data;
            state.in_house_works[data.station_id].loaded = true;
            state.need_update_inhouse_view = data.station_id;
        },

        SET_NEED_UPDATE_INHOUSE(state, data){
            state.need_update_inhouse_view = data;
        },
      
        SET_EXP_RESPONSIBLES(state, data){

        }
    },
    actions: {
            /**
         * Получает список экспериментов и записывает
         * @param {Object} ctx
         * @param {String|Number} page Номер страницы
         * @returns {Object} Список экспериментов
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         *
         */
        async GET_CALENDAR_LIST(ctx, data) {
            try {
                const res = await axios.get(CALENDAR_LIST_URL + `?station_id=${data.station_id}`, {
                    headers: {
                    Authorization: `Token ${localStorage.token}`,
                    },
                });
                await ctx.commit('UPDATE_CALENDAR_LIST', {station_id: data.station_id, data: res.data});    
                return res;
            } catch (e) {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            console.log('exp', e);
            throw e;
            }
        },

            /**
         * Получает список экспериментов и записывает
         * @param {Object} ctx
         * @param {String|Number} page Номер страницы
         * @returns {Object} Список экспериментов
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         *
         */
        async GET_CALENDAR_MS_LIST(ctx, data) {
            try {
                const res = await axios.get(CALENDAR_LIST_URL + `?ms_list=true`, {
                    headers: {
                    Authorization: `Token ${localStorage.token}`,
                    },
                });
                return res;
            } catch (e) {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            console.log('exp', e);
            throw e;
            }
        },

        async GET_STATION_WORKLOAD(ctx, data) {
            try {
                const res = await axios.get(STATION_WORKLOAD_URL + `?station_id=${data.station_id}&start=${data.start}`, {
                    headers: {
                    Authorization: `Token ${localStorage.token}`,
                    },
                });
                return res;
            } catch (e) {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            console.log('exp', e);
            throw e;
            }
        },


            /**
         * Получает список экспериментов by Proposal
         * @param {Object} ctx
         * @returns {Object} Список экспериментов
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         *
         */
        async GET_PROPOSAL_LIST(ctx, data) {
                try {
                    const res = await axios.get(CALENDAR_LIST_URL + `?proposal_id=${data.proposal_id}`, {
                        headers: {
                        Authorization: `Token ${localStorage.token}`,
                        },
                    });
                    return res.data;
                } catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log('exp', e);
                throw e;
                }
        },
    

            /**
         * Получает список in-house and additional works и записывает
         * @param {Object} ctx
         * @returns {Object} Список список in-house and additional works 
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         *
         */
            async GET_INHOUSE_LIST(ctx, data) {
                try {
                    const res = await axios.get(CALENDAR_LIST_URL + `?station_id=${data.station_id}&active_inhouse=true`, {
                        headers: {
                        Authorization: `Token ${localStorage.token}`,
                        },
                    });
                    await ctx.commit('UPDATE_INHOUSE_LIST', {station_id: data.station_id, data: res.data});
        
                    return res;
                } catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log('exp', e);
                throw e;
                }
            },

        /**
         * Обновляет list of responsibles for calendar rec
         * @param {Object} ctx
         * @param {Object} data Данные 
         * @returns {Object} Результат 
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async UPDATE_EXP_RESPONSIBLES(ctx, data) {
            try {
                const res = await axios.post(UPDATE_EXP_RESPONSIBLES_URL, data, {
                headers: {
                Authorization: `Token ${localStorage.token}`,
                },
            });
            if(res.data.status)
                await ctx.commit('SET_EXP_RESPONSIBLES', res.data);
            return res.data;
            } catch (e) {
            errorHelper(e);
            messageHelper('', 'error', 6000, e);
            console.log('UPDATE_EXP_RESPONSIBLES', e);
            //   return {'data' : {'error' : e.message}}
            throw e;
            }
        },
              
        /**
         * Обновляет  calendar rec
         * @param {Object} ctx
         * @param {Object} data Данные 
         * @returns {Object} Результат 
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async UPDATE_CALENDAR_REC(ctx, data) {
            try {
                const res = await axios.post(UPDATE_CALENDAR_REC_URL, data, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                });
                return res.data;
                } 
            catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log('UPDATE_CALENDAR_REC', e);
                //   return {'data' : {'error' : e.message}}
                throw e;
            }
        },
              
        /**
         * create  calendar rec
         * @param {Object} ctx
         * @param {Object} data Данные 
         * @returns {Object} Результат 
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async ADD_CALENDAR_REC(ctx, data) {
            try {
                const res = await axios.patch(UPDATE_CALENDAR_REC_URL, data, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                });
                return res.data;
                } 
            catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log('UPDATE_CALENDAR_REC', e);
                //   return {'data' : {'error' : e.message}}
                throw e;
            }
        },

        /**
         * delete  calendar rec
         * @param {Object} ctx
         * @param {Object} data Данные 
         * @returns {Object} Результат 
         * @throws {Object} Ошибка запроса данных
         *
         * @memberof Main
         */
        async DELETE_CALENDAR_REC(ctx, data) {
            try {
                const res = await axios.post(DELETE_CALENDAR_REC_URL, data, {
                    headers: {
                        Authorization: `Token ${localStorage.token}`,
                    },
                });
                return res.data;
                } 
            catch (e) {
                errorHelper(e);
                messageHelper('', 'error', 6000, e);
                console.log('DELETE_CALENDAR_REC', e);
                //   return {'data' : {'error' : e.message}}
                throw e;
            }
        },
              
    },
    getters: {
        GETTERS_FULL_CALENDAR(state) {
            return state.calendarsData
        },
        GETTERS_STATION_CALENDAR: (state) => (id) => {
            return state.calendars_by_station[id]
        },
        GETTERS_CALENDAR_INIT(state) {
            return state.isInit
        },
        GETTERS_STATION_INHOUSES: (state) => (id) => {
            return state.in_house_works[id]
        },
        GETTERS_INHOUSES(state){
            return state.in_house_works
        },
        GETTERS_UPDATE_CURRENT_CALENDAR(state){
            return state.updateCurrent
        },
        GETTERS_UPDATE_CURRENT_INHOUSE_VIEW(state){
            return state.need_update_inhouse_view
        },
    }
}